import { useVideoAd } from "../presentation/VideoAdContext";
import { normalizePosition } from "../utils/position";

import DisplayFallback from "./DisplayFallback";
import { H5Fallback } from "./H5Fallback";

export const Fallback = () => {
  const { session, state } = useVideoAd();

  if (state.runtime.fallback === "h5") {
    return (
      <H5Fallback
        onFinish={() => session.finish()}
        position={normalizePosition(state.config)}
      />
    );
  } else {
    return <DisplayFallback />;
  }
};

export default Fallback;
